function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#71BDD0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1198 30.52H17.8798C14.6398 30.52 12.0698 27.6 12.0698 24C12.0698 20.4 14.6898 17.48 17.9298 17.48H30.1198C33.3598 17.48 35.9798 20.4 35.9798 24C35.9798 27.6 33.3598 30.52 30.1198 30.52Z",
  fill: "white",
  stroke: "#292929",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0698 13V17.48",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8398 13V17.48",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2799 16.25L34.4399 19.42",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2799 31.7501L34.4399 28.5801",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4399 13V17.48",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0698 30.52V35",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8398 30.52V35",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4399 30.52V35",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M8 23.9299H12",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7197 31.7501L13.5597 28.5801",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7197 16.25L13.5597 19.42",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4997 21.9199C31.8297 22.6299 31.1597 22.0099 30.4997 22.7199C29.8397 23.4299 30.4997 24.0599 29.8297 24.7799C29.1597 25.4999 28.4897 24.8699 27.8297 25.5899C27.1697 26.3099 27.8297 26.9299 27.1597 27.6499",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2598 20.47V25",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M21.29 22.73H17.23",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9497 24H39.9497",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

function SvgAntibiotic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntibiotic);
export default __webpack_public_path__ + "static/media/antibiotic.fbf70ce1.svg";
export { ForwardRef as ReactComponent };